import css from "styled-jsx/css";

export default css`
    .alert-content {
        display: flex;
        flex-direction: column;
        gap: 4px;
    }
`;
